import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import "./App.css";
import MainLayOut from "./component/MainLayOut";
import { useEffect } from "react";
import Home from "./pages/Home";
import Gallery from "./pages/gallery/Gallery";
import Contact from "./pages/contact/Contact";
import Blog from "./pages/blog/Blog";
import DirectorMessage from "./pages/about/DirectorMessage";
import AboutUs from "./pages/about/AboutUs";
import PrincipalsMessage from "./pages/about/PrincipalsMessage";
import VisionAndMission from "./pages/about/VisionAndMission";
import Facility from "./pages/facility/Facility";
import Admission from "./pages/admission/Admission";
import TopResult from "./pages/result/TopResult";
import Activities from "./pages/activities/Activities";
import OurVideos from "./pages/videos/OurVideos";
import BlogDetails from "./pages/blog/BlogDetails";


function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <div>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" exact element={<MainLayOut />}>
            <Route index element={<Home />} />
            <Route path="/about-us" element={<AboutUs />} />
            <Route path="/PrincipalsMessage" element={<PrincipalsMessage />} />
            <Route path="/director-message" element={<DirectorMessage />} />
            <Route path="/VisionAndMission" element={<VisionAndMission />} />
            <Route path="/Facility" element={<Facility />} />
            <Route path="/activities" element={<Activities />} />
            <Route path="/Admission" element={<Admission />} />
            <Route path="/top-result" element={<TopResult />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/videos" element={<OurVideos />} />
            <Route path="/blog-details" element={<BlogDetails />} />
            <Route path="/contact" element={<Contact />} />
           
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
